
import { MapIconIMG } from '../shared/mapa/mapa-tools/mapa-icons-img';
import { DomSanitizer } from '@angular/platform-browser';
import { Gtp } from '../shared/gtp';

export class MovilRecorridoResumenLista {

    markerpos:number;
    latitud:number;
    longitud:number;
    evento:string;
    orientacion:number;
    velocidad:number;
    fecha:string;
    panico:string;
    icono:any;
    direccion:string;
    //direccion_google:string;

    iconImg = new MapIconIMG();

    constructor(data: any, posData) {
        let gtp = new Gtp();
        //console.log(data)
        //let duracion = gtp.getDuration(data.duration);
        // this.latitud = parseFloat(posData.latitud);
        // this.longitud = parseFloat(posData.longitud);
        this.latitud = parseFloat(data.latitud);
        this.longitud = parseFloat(data.longitud);
        this.orientacion = parseFloat(data.orientacion);
        this.markerpos = posData.markerpos;
        this.velocidad = data.velocidad;
        this.evento = (data.des_evento) ? data.des_evento : false;
        this.fecha = data.fecha;
        this.panico = (data.panico) ? data.panico : 'NO';
        this.orientacion = ( data.orientacion ) ? data.orientacion : 0;
        this.direccion = ( data.direccion ) ? data.direccion.formateada : 'S/N';
        //this.direccion_google = ( data.direccion ) ? data.direccion.formateada_google : 'Sin direccion desde google';

        let icono = this.iconImg.punto('#FF415B');
        if(!this.evento) {
            icono = (data.pointtype == "ParadasTiempo") ? this.iconImg.stop(30, 30, '#F43734') : this.iconImg.flecha( 30, 30, this.orientacion );
        }
        if(this.panico=="Si") {
                icono = this.iconImg.alerta();
        } else {
            //Contacto ON //Contacto OFF
            if(data.cod_evento==23 || data.cod_evento==24) {
                icono = this.iconImg.eventoContacto(data.cod_evento);
            }
        }
        this.icono = icono;
    }

}
